import React, {
  FC, useEffect,
} from 'react';
import {
  Button,
} from './Styles';
import Header from '../../Common/Header';
import { updateFoodifoxData } from '../../../../lib/axios/FoodifoxDataAPI';
import { languageChangeWhite } from '../../../../assets/Svg';
import { startBackground } from '../../../../assets/base64Images/ai/startBackground';
import { robotIcon } from '../../../../assets/base64Images/ai/robotIcon';
import InterMediumText from '../../../../components/Text/InterMediumText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import InterRegularText from '../../../../components/Text/InterRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import InterBoldText from '../../../../components/Text/InterBoldText';

const SupportPage: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setTargetPage,
  // AI对话验证的手机号，每次进入都需要验证
  setShowCheckPhoneNumberPage,
}) => {
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <img src={startBackground} style={{ width: '100%', height: 295 }} />
      <div style={{ paddingTop: 50, paddingBottom: 60, marginTop: -295 }}>
        {/* 头部 */}
        <Header
          showSupport={false}
          showFAQ={false}
          showBackIcon={true}
          backToPage={'home'}
          setTargetPage={setTargetPage}
          isEnglish={isEnglish}
          setIsEnglish={setIsEnglish}
          backIconColor={'#FFFFFF'}
          languageColor={'#FFFFFF'}
          languageIcon={languageChangeWhite}
        />

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <img src={robotIcon} style={{ width: 140, height: 140 }} />
        </div>
      </div>

      {
        isEnglish ? (
          <InterMediumText color={'#15274E'} fontSize={36} lineHeight={44} marginTop={30} textAlign={'center'}>
            How may I help
            <br />
            you today?
          </InterMediumText>
        ) : (
          <PingFangMediumText color={'#15274E'} fontSize={36} lineHeight={44} marginTop={50} textAlign={'center'}>自助开柜系统</PingFangMediumText>
        )
      }

      <div style={{ fontSize: 16, fontFamily: isEnglish ? 'Squad-Regular, Squad' : 'PingFangSC-Regular, PingFang SC', fontWeight: 400, lineHeight: isEnglish ? '22px' : '27px', color: '#6D6D6D', textAlign: 'center', marginTop: 35 }}>
        {
          isEnglish ? (
            <InterRegularText fontSize={16} lineHeight={22} color={'#595E61'} opacity={0.5} textAlign={'center'} marginTop={30}>
              To find your order I need to confirm your
              <br />
              identity by asking a few questions.
            </InterRegularText>
          ) : (
            <PingFangRegularText fontSize={16} lineHeight={22} color={'#595E61'} opacity={0.5} textAlign={'center'} marginTop={30}>
              为了找到您的订单
              <br />
              我需要通过问几个问题来确认您的身份。
            </PingFangRegularText>
          )
        }
      </div>

      <Button
        style={{
          marginTop: 65,
          marginLeft: 'auto',
          marginRight: 'auto',
          width: 254,
          height: 71,
          background: '#15274E',
          borderRadius: 36,
        }}
        onClick={() => {
          setShowCheckPhoneNumberPage(true);
        }}
      >
        {
          isEnglish ? (
            <InterBoldText fontSize={20} color={'#FFFFFF'}>Start a new chat</InterBoldText>
          ) : (
            <PingFangMediumText fontSize={20} color={'#FFFFFF'}>开启对话</PingFangMediumText>
          )
        }
      </Button>

      <div
        style={{
          marginTop: 17,
          marginLeft: 'auto',
          marginRight: 'auto',
          width: 202,
        }}
        onClick={() => {
          location.href = 'tel:1300359889';
          saveCallLog({
            param: {
              cabId: cabId32Str,
              telNumber: '1300359889',
            },
          });
        }}
      >
        {
          isEnglish ? (
            <InterMediumText fontSize={18} lineHeight={24} color={'#15274E'} textDecorationLine={'underline'} textAlign={'center'}>Call for support</InterMediumText>
          ) : (
            <PingFangMediumText fontSize={18} lineHeight={24} color={'#15274E'} textDecorationLine={'underline'} textAlign={'center'}>拨打人工电话</PingFangMediumText>
          )
        }
      </div>
    </>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setTargetPage: (targetPage: string) => void;
  // AI对话验证的手机号，每次进入都需要验证
  setShowCheckPhoneNumberPage: (show: boolean) => void;
}

export default SupportPage;
